@if (isFormNotEmpty()) {
  <gstar-form-viewer
    [source]="formSchema()"
    (updateForm)="updateDynamicForm($event)" />
}
<ap-modal
  #modal
  [style]="'width: 540px'"
  appModalId="modal-no-rule-engine"
  [title]="'upsertSecurity.noRulesWarningTitle' | translate">
  <p>{{ 'upsertSecurity.noRulesWarningMessage' | translate }}</p>
</ap-modal>
